import paths from '../paths';
import { KisaanClient } from './axiosKisaanClient';
import { IRecomendedProductNudge } from '@ninjacart/nc-nk-core';

export const getVideosRecommendedProducts = async (videoId: string,type:string) => {
  try {
    const response = await KisaanClient.post<IRecomendedProductNudge>(
      paths.getRecommendedProducts(videoId,type),
      {}
    );
    return response.data?.data;
  } catch (error) {
    console.log('error getVideosRecommendedProducts', error);
    throw error;
  }
};
